export default __webpack_public_path__ + "KeplerStd-Italic.woff2";